import type { FaireProductEntity } from "../../entity_types/product";

export const p_74mywccd8p: FaireProductEntity = {
  token: "p_74mywccd8p",
  type: "product",
  name: "Organic Extra Virgin Olive Oil | Single-Harvest / Case",
  brandToken: "b_9rg83ni1sw",
  brandName: "Le Marké",
  imageUrl:
    "https://cdn.faire.com/fastly/020666865f6103abb152a28eac9d3afe48656d4bc1d9d99b12a00fb844785206.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e8df0e31462040e66bf2e8a8e86c27c13a6493cd8bbf55fa654a70dde7f3808.png",
    "https://cdn.faire.com/fastly/51fe9679f839fc7a9ed55b145e791bd627381efcbf629f3d6a69ebc4b7a933d8.png",
    "https://cdn.faire.com/fastly/f537aa04d2bab45078c0da33769c97698cddc5314d65266dc36749b7100b9d4c.png",
    "https://cdn.faire.com/fastly/26367770eeab2cab423f2e46e062e5b438603fa1fa05744565385fe00ec4aae4.png",
    "https://cdn.faire.com/fastly/060acfce83f9941d978157238710c7e85b8e50f4595757b046990a9cac15e727.png",
    "https://cdn.faire.com/fastly/b79260d2ee80b145b08a52b244e7b638a2f6dc051df069653df87dd16b148f32.png",
    "https://cdn.faire.com/fastly/76eecd6a43e00e0de50198caf98dc89e50d4f7c26a6d4797e2f05ff5e00f50fc.png",
  ],
  priceDollars: 21,
  description:
    "Retail $42 | Wholesale $21.00 | Case of 12 $252\n\nGrown, hand-harvested, cold-pressed, and bottled at our century-old organic grove on the shores of Lake Garda.\n\nOur single-harvest, extra virgin olive oil is pressed within hours of picking to preserve freshness, flavor, and naturally occurring antioxidants. Rich in polyphenols and crafted using regenerative farming methods, it reflects the unique soil and northern Italian microclimate of our grove.\n\nFull-bodied and well-rounded, with notes of fresh grass, herbs, artichoke, and sweet almond. Designed for cooking, roasting, finishing, and everyday use — from simple salads and grilled vegetables to fresh pasta and morning wellness shots.\n\nBottled in UV-protective glass to preserve purity and flavor, our signature vessel is meant to live on your counter — not hidden in a cupboard.\n\nA thoughtful hostess gift. A beautiful housewarming present. A refined wedding or holiday gift for the home cook. Bring this instead of wine.\n\nOrigin: Lake Garda, Italy\nHarvest: Single-Harvest, Early Harvest\nProcessing: Cold-Pressed Within Hours\nTasting Notes: Fresh Grass, Herbs, Artichoke, Sweet Almond\nBottle: UV-Protective Glass",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:24.622Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
